import { useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { C } from "./constants";
import { DecisionesEditor, EMPTY_DECISION, decisionesValid } from "./DecisionesEditor";
import { DelegationResult } from "./DelegationResult";

const initial = (ds) => (ds?.length ? ds.map((d) => ({ ...d })) : Array.from({ length: 5 }, () => ({ ...EMPTY_DECISION })));

export const Capa1Section = ({ testId, data, onSaved }) => {
  const [decisiones, setDecisiones] = useState(initial(data.decisiones));
  const [editing, setEditing] = useState(!data.result);
  const [saving, setSaving] = useState(false);

  async function save() {
    setSaving(true);
    try {
      const r = await api.put(`/consulting/tests/${testId}/tablero/capa1/decisiones`, { decisiones });
      onSaved(r.data);
      setEditing(false);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "No pudimos guardar las decisiones");
    } finally {
      setSaving(false);
    }
  }

  return (
    <section className="rounded-2xl p-6 md:p-8" style={{ background: C.mint }} data-testid="tablero-capa1">
      <div className="text-[10px] font-bold uppercase tracking-[0.22em]" style={{ color: C.gold }}>Capa 1 · Fundador</div>
      <h2 className="font-display text-xl md:text-2xl font-bold mt-1" style={{ color: C.text }}>¿Cuánto depende de mí?</h2>
      <p className="text-sm mt-2 mb-6" style={{ color: "#5B6B64" }}>Indica entre 5 y 12 decisiones recurrentes que hoy pasan por ti.</p>
      {editing ? (
        <>
          <DecisionesEditor decisiones={decisiones} setDecisiones={setDecisiones} />
          <button onClick={save} disabled={!decisionesValid(decisiones) || saving} className="mt-4 inline-flex items-center gap-2 rounded-full px-6 py-2.5 text-sm font-semibold text-white disabled:opacity-40" style={{ background: C.green }} data-testid="tablero-capa1-save">
            {saving && <Loader2 className="w-4 h-4 animate-spin" />} Ver qué puedo delegar
          </button>
        </>
      ) : (
        <>
          <DelegationResult rows={data.result} contador={data.contador} />
          <button onClick={() => setEditing(true)} className="mt-4 text-sm font-semibold underline" style={{ color: C.green }} data-testid="tablero-capa1-edit">Cambiar mis decisiones</button>
        </>
      )}
    </section>
  );
};
